// extracted by mini-css-extract-plugin
export default {"main":"Temperature_main__f+fGV"};